import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-5 py-8 sm:py-16 items-center justify-center bg-[#0A0A0A]" data-id="element-106">
      {/* Logo */}
      <span className="text-[#00A650] text-lg sm:text-xl font-black tracking-widest mb-3 uppercase" data-id="element-107">
        ⚽ FÚTBOL LISTO 360
      </span>

      {/* Badge */}
      <div className="mb-4" data-id="element-108">
        <span className="bg-[#00A650]/10 text-[#00A650] text-[10px] sm:text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide border border-[#00A650]/20" data-id="element-109">
          ⚽ +2.000 entrenadores ya usan este sistema
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-4xl text-2xl sm:text-4xl md:text-5xl leading-[1.1] mb-4 tracking-tight" data-id="element-110">
        Planifica una temporada completa de fútbol juvenil en solo{' '}
        <span className="text-[#00A650]" data-id="element-111">5 minutos.</span>
      </h1>

      {/* Subheadline */}
      <p className="text-[#B0B0C0] text-sm sm:text-lg max-w-2xl mx-auto mb-5 font-medium leading-relaxed" data-id="element-112">
        El sistema completo para entrenadores que quieren marcar la diferencia.
      </p>

      {/* Bullets — compact */}
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-6 max-w-2xl" data-id="element-113">
        {['6 Volúmenes', '5 Bonos', '250 Páginas', '101 Ejercicios', 'U8-U17'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-114">
            <span className="text-[#00A650] text-sm" data-id="element-115">✅</span>
            <span className="text-white text-xs sm:text-sm font-semibold" data-id="element-116">
              {item}
            </span>
          </div>)}
      </div>

      {/* Mockup image — smaller */}
      <div className="relative w-full max-w-[220px] sm:max-w-[340px] mx-auto mb-6" data-id="element-117">
        <img src="https://cdn.magicpatterns.com/uploads/2F3GBzs1nxx42sEXLWWEmj/ChatGPT_Image_29_jun_2026,_09_28_49-Photoroom.png" alt="FÚTBOL LISTO 360 — El Kit Completo" className="w-full h-auto object-contain drop-shadow-2xl" width={600} height={600} fetchPriority="high" data-id="element-118" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-10 bg-[#00A650] opacity-20 rounded-full pointer-events-none" style={{
        filter: 'blur(40px)'
      }} data-id="element-119" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-6 rounded-2xl transition-colors inline-block mb-4 w-full sm:w-auto max-w-md shadow-xl" data-id="element-120">
        🚀 QUIERO FÚTBOL LISTO 360 AHORA
      </a>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-[#B0B0C0] text-[11px] sm:text-sm font-medium" data-id="element-121">
        <span className="flex items-center gap-1.5" data-id="element-122">🔒 Pago Seguro</span>
        <span className="flex items-center gap-1.5" data-id="element-123">⚡ Acceso Inmediato</span>
        <span className="flex items-center gap-1.5" data-id="element-124">🛡️ Garantía 7 Días</span>
      </div>
    </section>;
}